/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged,
  m11ReportSection12FoiChanged, m11ReportSection12ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection12Foi, selectM11ReportSection12Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import StringEntry from "../../datatypeComponents/StringEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveSupportingDetailsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section12State, setAlertModalState, setStartingSection12State) => {

  let changesStates = {
    section12State: section12State
  };
  let response = await saveM11Changes(apiToken, 43, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportSection12Resource) {
      dispatch(m11ReportSection12ResourceChanged(response.m11ReportSection12Resource));
    }
    setStartingSection12State(JSON.parse(JSON.stringify(section12State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step043AdditionalAppendices = forwardRef(({ setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection12Foi = useSelector(selectM11ReportSection12Foi);
  const m11ReportSection12Resource = useSelector(selectM11ReportSection12Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section12State, setSection12State] = useState({
    "section12xStatus": "empty", "section12xXhtml": "",
    "index": 3, "number": 4, "appendixTitle": ""
  });
  const [startingSection12State, setStartingSection12State] = useState({
    "section12xStatus": "empty", "section12xXhtml": "",
    "index": 3, "number": 4, "appendixTitle": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section12State, startingSection12State)),
    async saveAllChanges() {
      await saveSupportingDetailsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section12State, setAlertModalState, setStartingSection12State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section12xStatus": "empty", "section12xXhtml": "",
        "index": 3, "number": 4, "appendixTitle": "",
        "loaded": true
      };
      setSection12State(startingData);
      setStartingSection12State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[12]?.entry?.length) {
        let m11ReportSection012Foi = getIdFromReference(m11ReportContainerResource.section[12].entry[0]);
        if (m11ReportSection012Foi && !isNaN(m11ReportSection012Foi) && m11ReportSection012Foi !== m11ReportSection12Foi) {
          dispatch(m11ReportSection12FoiChanged(m11ReportSection012Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection12Foi && !isNaN(m11ReportSection12Foi)) {
      loadResource(m11ReportSection12Foi, "M11ReportSection12", apiToken, dispatch);
    }
  }, [m11ReportSection12Foi]);

  useEffect(() => {
    if (m11ReportSection12Resource && Object.keys(m11ReportSection12Resource).length > 0) {
      let startingData = {
        "section12xStatus": "empty", "section12xXhtml": "",
        "index": 3, "number": 4, "appendixTitle": "",
        "loaded": true
      };
      if (m11ReportSection12Resource.section?.[0]?.section?.length > 0) {
        startingData.index = m11ReportSection12Resource.section[0].section.length;
        startingData.number = m11ReportSection12Resource.section[0].section.length + 1;
        setSection12State(startingData);
        setStartingSection12State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection12Resource]);

  return <div>
    <h3>Complete Section 12 Supporting Details</h3>
        {!(m11ReportSection12Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) and Step 43 (Start Section 12 Supporting Details) before filling in M11 Report Section details and Section 12.X additional details.</h1>
        }
    <p>If there are no additional appendices, go the next step without saving any changes.</p>
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 43 (Complete Section 12 Supporting Details) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section12State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Add Section 12.{section12State.number} Additional Appendix</h4>
          <h4 style={{ marginBottom: "0px" }}>Enter the Title of Appendix</h4>
          <StringEntry elementName="appendixTitle" fieldLabel="Title of Appendix"
            startingValue={section12State.appendixTitle}
            setResourceState={setSection12State} />
          <h4 style={{ marginBottom: "0px" }}>Enter the additional appendix.</h4>
          <TextDivEntry elementName="section12xXhtml"
            startingValue={section12State.section12xXhtml}
            setResourceState={setSection12State} />
        </>}
      </>
    }
  </div>
});

const M11Step043AdditionalAppendicesHelperText = <div>
  <h3>Complete Section 12 Supporting Details</h3>
  <div style={{ textAlign: "left" }}>
    <p>If there are no additional appendices, go the next step without saving any changes.</p>
    <p>For each additional appendix:</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Enter the Title of Appendix</p>
      <p>Enter the data to represent the additional appendix.</p>
      <p>Click the 'Save All Changes' button.</p>
    </div>
  </div>
</div>
// eslint-disable-next-line no-empty-pattern
const M11Step043AdditionalAppendicesValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 43, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 43 (Complete Section 12 Supporting Details) {validationCheckState.step43numberOfChecks} issues checked. {validationCheckState.step43numberPassed} passed. {validationCheckState.step43numberFailed} failed.</h4>
    <p>If present, Section 12.X (Additional Appendix) where X is 4 or greater has content: {validationCheckState.resultCheckSection12XContent}</p>
    </div>}  </div>
}

export default M11Step043AdditionalAppendices;
export { M11Step043AdditionalAppendicesHelperText, M11Step043AdditionalAppendicesValidationCheck };